// #region IMPORTS
import { useAppAuth } from './authAdapter';
import { useEffect, useState } from 'react';
// #endregion

// #region HOOK
// Exposes the AZmed app metadata read from the current user's ID token claims.
export const useUserMetadata = () => {
  // #region INITIALIZATION
  const { user, getIdTokenClaims } = useAppAuth();
  const [metadata, setMetadata] = useState(null);
  // #endregion

  // #region HOOK
  // Reload the metadata whenever the user or the claims getter changes
  useEffect(() => {
    // Read the ID token claims and store their app metadata
    const getTokenAndMetadata = async () => {
      if (!user) {
        setMetadata(null);
        return;
      }

      try {
        const idTokenClaims = await getIdTokenClaims();
        if (!idTokenClaims) {
          setMetadata(null);
          return;
        }

        const namespace = 'https://myapp.azmed.co/';
        setMetadata(idTokenClaims[`${namespace}app_metadata`]);
      } catch (err) {
        console.error('Erreur lors de la récupération du token:', err);
      }
    };

    getTokenAndMetadata();
  }, [getIdTokenClaims, user]);
  // #endregion

  // #region INTERFACE
  return { metadata };
  // #endregion
};
// #endregion
